import { CostTypeBase } from './base/cost-type-base';

export class CostType extends CostTypeBase { }